import { BackButton } from '@airship-platform/airship-patterns';
import { EmptyState } from '@airship-platform/jam-web/components';
import { useEffect } from 'react';
import { useAppointmentProposalOptions } from '../../../data-access/appointmentProposalOptions/AppointmentProposalOptionsProvider';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals/AppointmentProposalsProvider';
import { useJobsActivities } from '../../../data-access/jobsActivitiesTracking';
import { SectionWrapper } from '../../../patterns';
import ActivitySection from './sections/ActivitySection';

const ActivityPage: React.FC = () => {
  const { currentProposal, isLoading: isLoadingProposal } =
    useAppointmentProposals();
  const { options } = useAppointmentProposalOptions();
  const {
    fetchJobsActivities,
    jobsActivitiesGroupedByDate,
    isLoaded,
    isLoading: isLoadingActivities,
  } = useJobsActivities();

  useEffect(() => {
    if (currentProposal) {
      fetchJobsActivities(
        currentProposal.appointmentId,
        currentProposal.appointmentProposalId
      );
    }
  }, [currentProposal, fetchJobsActivities]);

  if (!currentProposal) {
    return (
      <EmptyState
        title="Activities from proposal not found"
        subtitle="Oops! The requested proposal does not contain any activities."
      />
    );
  }

  return (
    <SectionWrapper
      maxWidth={'48rem'}
      width={'100%'}
      header="Activity"
      subheader=""
      actionsButtons={{
        left: {
          color: 'softGold',
          component: BackButton,
          label: 'Back',
        },
      }}
    >
      <ActivitySection
        isLoaded={isLoaded}
        isLoading={[isLoadingProposal, isLoadingActivities].some(Boolean)}
        options={options}
        activitiesGroupedByDate={jobsActivitiesGroupedByDate}
      />
    </SectionWrapper>
  );
};

export default ActivityPage;
